import SlaHeader from './SlaHeader';

export default SlaHeader;
